export { Text } from './Text';
export type { FontVariant, Props as TextProps } from './Text';
